import { createFileRoute } from "@tanstack/react-router";
import { ForgotPasswordForm } from "~/components/views/auth/forgot-password-form";

export const Route = createFileRoute("/auth/forgot-password/")({
	component: Page,
});

function Page() {
	return <ForgotPasswordForm />;
}
